export default "__VITE_ASSET__CtxCJtwG__"